import { createAction } from "redux-actions";

import { SYSTEM_TYPE } from "./types";

const setSystemType = createAction(SYSTEM_TYPE);

export const selectSystemType = (systemType) => async (dispatch) => {
  dispatch(setSystemType(systemType));
};
